module.exports = __webpack_public_path__ + "static/media/Nunito-Regular.6bd1a320.woff";